module.exports = __webpack_public_path__ + "img/user-06.74a75a96.jpg";